Acr = window.Acr || {};

Acr.DeepLinking = (function () {
  var Utility = window.Utility || {};
  var navHelperInitialized = false;
  var hasDeepLink = false;

  var calculateOffset = function (elementScrollTo, isOnLoad = false) {
    Utility = Utility || window.Utility;
    Utility.log('DeepLinking.js scrollDeepLink');

    const wrapper = Utility.getFirstElementFromClass('wrapper');
    const mainNav = Utility.getFirstElementFromClass('acr-nav');
    const stickyNav = Utility.getFirstElementFromClass('acr-sticky-nav');
    const mlpHeader = Utility.getFirstElementFromClass('mlp-nav');
    const grayCompNav = Utility.getFirstElementFromClass('rzf-gry-navigation-links-container');

    // Getting current header, stickynav and navbar height
    const offsetMainNav = mainNav ? mainNav.offsetHeight : 0;
    const offsetMlpNav = mlpHeader ? mlpHeader.offsetHeight : 0;
    var offsetStickyNav = 0;

    // Getting gray component nav size
    const grayCompNavList = grayCompNav ? grayCompNav.firstElementChild : null;
    const offsetGrayCompNav = grayCompNavList ? grayCompNavList.offsetHeight : 0;

    // Set size of main header
    var offsetMainHeader = offsetMainNav;
    if ((offsetMlpNav || offsetGrayCompNav) && !wrapper.classList.contains('expanded-nav')) {
      offsetMainHeader = 0;
    }

    // Checkig for sticky nav only on desktop, due to on mobile as it started expanded it generate unnecesary space
    if (stickyNav) {
      const stickyItem = stickyNav.querySelector('.acr-sticky-nav__item');
      const stickyItemHeight = stickyItem ? stickyItem.offsetHeight : 0;
      offsetStickyNav = !Utility.isDesktop() ? stickyNav.offsetHeight + stickyItemHeight : stickyNav.offsetHeight;
    }

    var offset = elementScrollTo.offsetTop - offsetMainHeader - offsetMlpNav - offsetGrayCompNav - offsetStickyNav;
    if (isOnLoad) {
      offset -= offsetMainHeader;
    }

    return offset;
  };

  var inPageDeepLink = function (deepLinkTo, offsetParam, navSelectorParam) {
    if (deepLinkTo) {
      const hashSelector = !Utility.isIE11() ? '[id="' + deepLinkTo + '" i]' : '[id="' + deepLinkTo + '"]';
      const elementScrollTo = document.querySelector(hashSelector);

      if (elementScrollTo) {
        var offset = calculateOffset(elementScrollTo);
        var navSelector = navSelectorParam.replace('.', '');
        const navSelectorItem = Utility.getFirstElementFromClass(navSelector);
        const navSelectorSize = navSelectorItem
          ? navSelectorItem.offsetHeight
          : 0;
        offset -= navSelectorSize;

        Utility.scrollTo(offset, 750);
      }
    }
  };

  var deepLink = function (initial, isOnLoad = false) {
    // Search for deeplink parameter to activate the deep linking functionality
    const params = new URLSearchParams(window.location.search);
    const deepLinkParam = params.get('deeplink');

    // Search for hash to support old functionality
    const hash = window.location.hash.replace('#', '');
    const deepLinkTo = hash || deepLinkParam;

    if (deepLinkTo) {
      const hashSelector = !Utility.isIE11() ? '[id="' + deepLinkTo + '" i]' : '[id="' + deepLinkTo + '"]';
      const elementScrollTo = document.querySelector(hashSelector);

      if (elementScrollTo && initial) {
        hasDeepLink = true;
        const offset = calculateOffset(elementScrollTo, isOnLoad);
        if (isOnLoad) {
          Utility.scrollTo(offset, 1000);
        } else {
          Utility.scrollTo(offset, 750);
        }
      }
    }

    if (!navHelperInitialized) {
      navHelperInitialized = true;
      Acr.NavHelper.init();
    }
  };

  var initDeepLinkEvent = function () {
    // Add event listener for internal hash links in the same page
    var btns = document.querySelectorAll('[data-deep-link]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function (evt) {
        evt.preventDefault();
        var internalDeepLink = evt.currentTarget.dataset.deepLink;
        const hashSelector = !Utility.isIE11() ? '[id="' + internalDeepLink + '" i]' : '[id="' + internalDeepLink + '"]';
        const elementScrollTo = document.querySelector(hashSelector);
        if (elementScrollTo) {
          const offset = calculateOffset(elementScrollTo);
          Utility.scrollTo(offset, 750);
        } else {
          window.location = evt.currentTarget.href;
        }
      });
    });
  };

  var initByElement = function (deeplinkTo) {
    if (deeplinkTo) {
      const offset = calculateOffset(deeplinkTo);
      Utility.scrollTo(offset, 750);
    }
  };

  var getTabIdHashElement = function (tabContainer) {
    var hashTab = null;
    if (location.hash) {
      const hash = location.hash.replace('#', '');
      const hashSelector = !Utility.isIE11() ? '.js-tab-link[tab-id="' + hash + '" i]' : '.js-tab-link[tab-id="' + hash + '"]';
      hashTab = tabContainer.querySelector(hashSelector);

      if (hashTab) {
        initByElement(tabContainer);
      }
    }
    return hashTab;
  };

  var init = function () {
    // Reset scroll top - Prevent automatic browser scroll on refresh
    history.scrollRestoration = 'manual';
    window.addEventListener('unload', function () {
      if (hasDeepLink) {
        window.scrollTo(0, 0);
      }
    });

    initDeepLinkEvent();

    Utility.log('DeepLinking.js inited');

    try {
      if (document.readyState === 'interactive') {
        deepLink(true, true);
      } else {
        document.onreadystatechange = function () {
          if (document.readyState === 'interactive') {
            deepLink(true, true);
          }
        };
      }
    } catch (e) {
      Utility.error(e.message);
    }
  };

  return {
    init: init,
    inPageDeepLink: inPageDeepLink,
    initByElement: initByElement,
    getTabIdHashElement: getTabIdHashElement,
  };
}());
